// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PD-z","modalContent":"QD-z","header":"RD-z","close":"SD-z"};